import * as CONSTANTS from 'constants';

const INIT_STATE = {
    searchResults: [],
    searchDevicesOrGateways: [],
    searchDeviceHistory: [],
    userVersionHistory: [],
    searchResultsError: null,
    searchErrors: null,
    errorStats: null,
    errorStatDetails: null,
    errorClaims: null,
    errorTimeSpan: 60,
    errorClaimHeaders: [
        {
            id: 0,
            title: 'blank',
            active: false,
            sortable: false,
            order: false,
            mobile: false,
            width: 60
        },
        {
            id: 1,
            title: 'comp.table.header.endPoint',
            active: true,
            sortable: true,
            order: true,
            sortTitle: 'endpoint',
            mobile: true,
            style: { textAlign: 'left' }
        },
        {
            id: 2,
            title: 'comp.table.header.branchName',
            active: false,
            sortable: true,
            order: true,
            sortTitle: 'branchName',
            mobile: false,
            style: { textAlign: 'left' }
        },
        {
            id: 3,
            title: 'comp.table.header.code',
            active: false,
            sortable: true,
            order: true,
            mobile: false,
            sortTitle: 'errorCode',
            style: { textAlign: 'left' }
        },
        {
            id: 4,
            title: 'comp.table.header.subcode',
            active: false,
            sortable: true,
            order: true,
            mobile: false,
            sortTitle: 'errorSubcode',
            style: { textAlign: 'left' }
        },
        {
            id: 5,
            title: 'form.events',
            active: false,
            sortable: true,
            order: true,
            mobile: false,
            sortTitle: 'eventCount',
            style: { textAlign: 'left' }
        },
        {
            id: 6,
            title: 'comp.table.header.userCount',
            active: false,
            sortable: true,
            order: true,
            mobile: false,
            sortTitle: 'userCount',
            style: { textAlign: 'left' }
        },
        {
            id: 7,
            title: 'comp.table.header.mondayID', // monday ID
            active: false,
            sortable: true,
            order: true,
            mobile: false,
            sortTitle: 'userCount',
            style: { textAlign: 'left' }
        },
        {
            id: 8,
            title: 'comp.table.header.lastReported',
            active: false,
            sortable: true,
            order: true,
            mobile: true,
            sortTitle: 'lastReported',
            width: 120,
            style: { textAlign: 'right' }
        }
    ],
    errorHeader: [
        {
            id: 1,
            title: 'comp.table.header.errorID',
            active: true,
            sortable: true,
            order: false,
            sortTitle: 'errorID',
            mobile: true,
            icon: true,
            width: 135,
            style: { textAlign: 'left' },
            defaultTitle: 'Error ID'
        },
        {
            id: 2,
            title: 'comp.table.header.type',
            active: false,
            sortable: true,
            order: true,
            mobile: true,
            sortTitle: 'code',
            width: 90,
            style: { textAlign: 'left' }
        },
        {
            id: 3,
            title: 'comp.table.header.endPoint',
            active: false,
            sortable: true,
            order: true,
            mobile: true,
            sortTitle: 'endpoint',
            style: { textAlign: 'left' }
        },
        {
            id: 4,
            title: 'comp.table.header.user',
            active: false,
            sortable: true,
            order: true,
            mobile: false,
            sortTitle: 'userFirstName',
            style: { textAlign: 'left' }
        },
        {
            id: 5,
            title: 'pages.sites.Type',
            active: false,
            sortable: true,
            order: true,
            mobile: false,
            sortTitle: 'siteName',
            style: { textAlign: 'left' }
        },
        {
            id: 6,
            title: 'form.url',
            active: false,
            sortable: true,
            order: true,
            mobile: false,
            sortTitle: 'url',
            laptop: true,
            style: { textAlign: 'left' }
        },
        {
            id: 7,
            title: 'comp.activity.dateStamp',
            active: false,
            sortable: true,
            order: true,
            mobile: false,
            sortTitle: 'timeStamp',
            width: 100,
            tablet: true,
            style: { textAlign: 'right' },
            defaultTitle: 'Timestamp'
        }
    ]
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CONSTANTS.SET_SEARCH_RESULTS: {
            return {
                ...state,
                searchResults: action.payload
            };
        }
        case CONSTANTS.SET_SEARCH_DEVICES_OR_GATEWAYS: {
            return {
                ...state,
                searchDevicesOrGateways: action.payload
            };
        }
        case CONSTANTS.SET_SEARCH_DEVICE_HISTORY: {
            return {
                ...state,
                searchDeviceHistory: action.payload
            }
        }
        case CONSTANTS.SET_USER_VERSION_HISTORY: {
            return {
                ...state,
                userVersionHistory: action.payload
            }
        }
        case CONSTANTS.SET_SEARCH_RESULTS_ERROR: {
            return {
                ...state,
                searchResultsError: action.payload
            };
        }
        case CONSTANTS.SET_ALL_SEARCH_ERRORS: {
            return {
                ...state,
                searchErrors: action.payload
            };
        }
        case CONSTANTS.SET_ERROR_STATS: {
            return {
                ...state,
                errorStats: action.payload
            };
        }
        case CONSTANTS.SET_ERROR_STAT_DETAILS: {
            return {
                ...state,
                errorStatDetails: action.payload
            };
        }
        case CONSTANTS.SET_ERROR_CLAIMS: {
            return {
                ...state,
                errorClaims: action.payload
            };
        }
        case CONSTANTS.SET_ERROR_TIMESPAN: {
            return {
                ...state,
                errorTimeSpan: action.payload
            };
        }
        case CONSTANTS.SET_ERROR_HEADER: {
            return {
                ...state,
                errorHeader: action.payload
            };
        }
        default:
            return state;
    }
};
